/**
 * simply utility that clamps a value between the provided minumum and maximum
 * value.
 *
 * @example
 * clamp(2, 1, 5) --> 2
 * clamp(2, 3, 5) --> 3
 * clamp(2, 6, 5) --> 5
 * clamp(2, [1, 2, 3, 4], 5) --> 4
 * clamp(10, 5, 2) --> 2
 */
export function clamp(
  min: number,
  values: number | number[],
  max: number
): number {
  if (Array.isArray(values)) {
    return Math.min(max, Math.max(...values, min));
  } else {
    return Math.min(max, Math.max(values, min));
  }
}
